import React, { useState } from "react";
import Header from "../../Components/header";
import Footer from "../../Components/footer";
import "../../assets/css/style.scss";
import aboutBanner from "../../assets/images/about-bg.jpg"


const Aboutus = () => {
    return (
        <>
            <div className="wrapper">
                <Header />
                <div className="image-box-container" style={{ backgroundImage: `url(${aboutBanner})` }}>
                    <div className="overlay-colored-Bg"></div>
                    <div className="container">
                        <div className="center-content">
                            <div className="banner-title">
                                <h1>Privacy Policy</h1>

                            </div>
                        </div>
                    </div>
                </div>
                <section className="pt-0 py-md-5 mt-md-5 mb-4 about-center-content">
                    <div className="container">
                        <div className="row panel-grid panel-no-style px-lg-5">

                            <div className="col-12 col-xl-12">
                                <div className="m-xl-5 px-3 px-md-0">
                                    <div className="notice_title">
                                        <h2 className="small-title--mt mb-3">~ Privacy Policy ~</h2>
                                        <p>
                                            <b>
                                                Updated at 10-11-2023
                                            </b>
                                        </p>
                                    </div>


                                    <p class="mt-3">
                                        <div class="abt_offr">Privacy Policy:
                                        </div>
                                        This Privacy Policy describes how we collects, uses, shares, and protects
                                        the personal information you provide when using our website
                                        and our services.
                                    </p>

                                    <p class="mt-3">
                                        <div class="abt_offr">Information We Collect: </div>
                                        When you visit our Site or make a purchase,
                                        we may collect personal information such as your name,
                                        email address, shipping/billing address,
                                        payment information, and browsing behavior.
                                    </p>

                                    <p class="mt-3">
                                        <div class="abt_offr">How We Use Your Information: </div>
                                        We use your information to process your orders,
                                        communicate with you, improve our services, and personalize your
                                        shopping experience. This may include sending promotional emails,
                                        newsletters, or updates about our products and services.
                                    </p>

                                    <p class="mt-3">
                                        <div class="abt_offr">Sharing Your Information: </div>
                                        We may share your information with trusted third parties who assist
                                        us in operating our website, conducting our business,
                                        or servicing you.
                                        These parties agree to keep this information confidential.
                                        We do not sell, trade, or rent your personal information to third parties.
                                    </p>


                                    <p class="mt-3">
                                        <div class="abt_offr">Cookies and Tracking Technologies: </div>

                                        We use cookies and similar tracking technologies to enhance your browsing
                                        experience on our Site, analyze trends, and gather information about
                                        our user base. You can control cookies through your browser settings.
                                    </p>


                                    <p class="mt-3">
                                        <div class="abt_offr">Security: </div>

                                        We implement security measures to protect your personal information.
                                        However, please note that no method of transmission over the internet
                                        or electronic storage is 100% secure, and we cannot guarantee absolute
                                        security.
                                    </p>

                                    <p class="mt-3">
                                        <div class="abt_offr">Your Rights: </div>

                                        You have the right to access, correct, or delete your personal information.
                                        You can also opt-out of receiving marketing communications
                                        from us by following the unsubscribe instructions in our emails.
                                    </p>

                                    <p class="mt-3">
                                        <div class="abt_offr">Changes to This Policy: </div>
                                        We reserve the right to update this Privacy Policy at any time.
                                        Any changes will be posted on this page with an updated date.
                                    </p>

                                    <p class="mt-3">
                                        <div class="abt_offr">Contact Us: </div>
                                        If you have any questions about this Privacy Policy, please contact us at contact@ownezzy.com.
                                    </p>


                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer />
            </div>
        </>
    )
}
export default Aboutus;